import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import Slider from 'react-slick';

import './carousel.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { CardWrapper, Card, CardSkeleton } from './styles';

const Slider3D = ({ route, lessons, loading }) => {
  const history = useHistory();

  const sliderSettings = {
    className: 'center',
    centerMode: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const renderSlider = () => {
    let listCards;

    if (loading) {
      listCards = Array(4)
        .fill()
        .map((item) => <CardSkeleton key={item} />);
    } else {
      listCards = lessons.map((item, index) => (
        <CardWrapper className="card-wrapper" key={item.title}>
          <Card
            loading={index > 2 ? 'lazy' : 'eager'}
            id={'card-' + item.id}
            onClick={() =>
              history.push({
                pathname: `/${route}/${item.id}`,
              })
            }
            src={item.thumbnail_url}
            alt={`${item.name} - Thumbnail da ${route}`}
            onLoad={() => {
              let cards = document.querySelectorAll('img#card-' + item.id);
              for (let card of cards) {
                card.style = 'opacity: 1; height: auto;';
              }

              let items = document.querySelectorAll('div#skeleton-' + item.id);
              for (let card of items) {
                card.style = 'display: none !important';
              }
            }}
          />
          <div id={`skeleton-${item.id}`}>
            <CardSkeleton />
          </div>
          {/* <div className="card-wrapper__description-container">
            <span className="card-wrapper__title">
              {item.title || item.name}
            </span>
            {item.description && (
              <span className="card-wrapper__description">
                {item.description}
              </span>
            )}

            {item.number_of_lessons && item.number_of_lessons !== null && (
              <span className="card-wrapper__description">
                {item.number_of_lessons === 1
                  ? `${item.number_of_lessons} video`
                  : `${item.number_of_lessons} vídeos`}
              </span>
            )}
          </div> */}
        </CardWrapper>
      ));
    }

    if (lessons.length > 3 || loading) {
      return <Slider {...sliderSettings}>{listCards}</Slider>;
    } else if (lessons.length > 1) {
      return (
        <Slider {...sliderSettings}>
          {listCards}
          {listCards}
        </Slider>
      );
    } else {
      return (
        <Slider {...sliderSettings}>
          {listCards}
          {listCards}
          {listCards}
          {listCards}
        </Slider>
      );
    }
  };

  return <>{renderSlider()}</>;
};

export default memo(Slider3D);
